import { render, staticRenderFns } from "./ImpersonateModal.vue?vue&type=template&id=64fb9a55&"
import script from "./ImpersonateModal.vue?vue&type=script&lang=js&"
export * from "./ImpersonateModal.vue?vue&type=script&lang=js&"
import style0 from "./ImpersonateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports